import dbg from "@utils/dbg";
import { useMe } from "@utils/hooks/useMe";
import { UserRole } from "./responses/AccountResponse";
import { useAuth } from "@utils/hooks/useAuth";

const TechUserApis = [
  "/version",
  "/socket",
  "/logoff",
  "/create_2fa",
  "/reset_2fa_end",
  "/complete2fa",
  "/user/relogon",
  "/radiolabels/w2ui",
  "/radiolabels/templates/w2ui",
  "/radiolabels/history/w2ui",
  "/radiolabels/file/upload",
  "/radiolabels/file/remove",
  "/logon",
  "/reset_2fa_start",
  "/user/verify",
  "/user/verify_email",
];

const checkURLForTech = (url: string) => TechUserApis.filter(x => url.endsWith(x)).length > 0;

const useApiRoleGuard = () => {
  const me = useMe();
  const auth = useAuth(); // isAdmin актуальнее здесь

  return {
    allowURL(url: string): boolean {
      if (!auth.isAdmin && url.includes("/admin/")) {
        dbg.trace(`ERROR! Admin API called from non-admin user, url: ${url}, role: ${me?.role ?? UserRole.Unknown}, isAdmin: ${!!me?.is_admin}`);
        return false;
      }

      if (me?.role === UserRole.Tech) {
        const allow = checkURLForTech(url);
        if (!allow) dbg.trace(`ERROR! Non-tech API called from tech user, url: ${url}, role: ${me?.role ?? UserRole.Unknown}, isAdmin: ${!!me?.is_admin}`);
        return allow;
      }

      return true;
    },

    role: me?.role ?? UserRole.Unknown,
    isAdmin: auth.isAdmin,
    email: me?.email ?? "",
  }
}

export default useApiRoleGuard;